var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatShape({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 443,
    height: 592,
    viewBox: "0 0 443 592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-nat-shape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443,
    height: 592
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nat-shape",
    clipPath: "url(#clip-nat-shape)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nat-test-shape",
    transform: "translate(-25.672 163.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4.267 -336.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M653.8,515.192c44.678,47.286,30.313,154.5,17.541,202.206l261.74-453.341L297.046-336.88,4.267-225.178C15.784-188.53,67.655-99.121,183-34.677c144.179,80.555,27.9,177.3,120.552,326.16S597.952,456.084,653.8,515.192Z",
    transform: "translate(-4.267 336.88)",
    fill: "#016ed3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M159.572-21c0,12.189.928,43.553,61.4,74.772C296.563,92.8,331.22,104.8,341.59,157.743s4.093,222.678,77.5,290.082c58.726,53.923,125.348,99.878,171.648,109.429",
    transform: "translate(-70.543 -143.479)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M264.572-36c25.834,24.469,79.6,55.868,120.617,67.4,43.662,12.28,68.222,42.844,68.222,77.774s-14.463,141.9,16.373,223.77c24.669,65.494,94.693,104.608,138.9,115.432",
    transform: "translate(-118.236 -136.666)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M373.072-161c13.554,19.648,88.466,82.9,116.524,99.878,32.474,19.648,66.826,37.294,60.036,87.871-3.027,22.546-28.125,134.56,0,185.019,27.835,49.939,100.606,55.124,129.9,55.124",
    transform: "translate(-167.519 -79.888)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatShape);
export default __webpack_public_path__ + "static/media/nat-shape.9b9b38058f7a8148f6bc406e6acb12c6.svg";
export { ForwardRef as ReactComponent };